<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" v-if="item.meta.title">
        <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{item.meta.title}}</span>
        <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)
      const first = matched[0]
      if (first && first.name !== 'home') {
        matched = [{ path: '/home', meta: { title: '首页' }}].concat(matched)
      }
      const r = this.$route
      this.levelList = matched.map(item => {
        if (item.name === 'addOrder' && r.query && r.query.id != null && String(r.query.id) !== '') {
          return { ...item, meta: { ...item.meta, title: '编辑订单' } }
        }
        return item
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  @import "@/styles/variables.scss";

  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;

    .el-breadcrumb__inner a,
    .el-breadcrumb__inner.is-link {
      color: $navbarTextMuted;
      font-weight: 500;
    }

    .el-breadcrumb__separator {
      color: #c8b08a;
    }

    .no-redirect {
      color: $navbarAccent;
      cursor: text;
      font-weight: 600;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue